<template>
  <div class="process-definition-action">
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      :label-col="{
        span: 3,
      }"
      :wrapper-col="{
        span: 21,
      }"
    >
      <a-form-item ref="name" label="流程定义名称" name="name">
        <a-input v-model:value="formState.name" />
      </a-form-item>
      <a-form-item ref="remark" label="备注" remark="remark">
        <a-input v-model:value="formState.remark" />
      </a-form-item>
      <a-form-item
        ref="processNodeIds"
        label="流程节点选择"
        remark="processNodeIds"
      >
        <a-transfer
          v-model:target-keys="formState.processNodeIds"
          :data-source="processNode"
          show-search
          :filter-option="filterOption"
          :render="(item) => item.title"
          :list-style="{
            width: '350px',
            height: '500px',
          }"
          :disabled="props.isEdit"
        >
          <template #footer="{ direction }">
            <p v-if="direction === 'left'">
              &nbsp;&nbsp;&nbsp;提示：请按顺序勾选，再统一添加到右侧
            </p>
          </template>
        </a-transfer>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 14, offset: 8 }">
        <a-button type="primary" @click="onSubmit">提交</a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
      </a-form-item>
    </a-form>
    <Line
      :processNode="processNode"
      :selected="formState.processNodeIds"
    ></Line>
  </div>
</template>
<script setup>
  import {
    reactive,
    ref,
    toRaw,
    defineProps,
    defineEmits,
    onMounted,
  } from 'vue'
  import { message } from 'ant-design-vue'
  import { createProcDef, updateProcDef, getProcNode } from '@/api/process'
  import {
    dataToOptions,
    constantToOptions,
    dataToDataSource,
  } from '@/utils/format'
  import Line from '../processLine/'

  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    treeData: Array,
  })

  //请求流程节点
  const processNode = ref([])
  async function fetch() {
    const res = await getProcNode()
    if (res.success)
      processNode.value = dataToDataSource(res.data, {
        key: 'process_node_id',
        keepOtherData: true,
      })
  }
  onMounted(fetch)

  //表单填写
  const formRef = ref()
  const defaultFormState = props.isEdit
    ? {
        ...props.editData,
        processDefinitionId: props.editData.process_definition_id,
        processNodeIds:
          props.editData?.definitionNodeList &&
          props.editData.definitionNodeList.map((item) => item.process_node_id),
      }
    : {
        name: '',
        remark: '',
        processNodeIds: [],
      }
  const formState = reactive(defaultFormState)

  const filterOption = (inputValue, option) => {
    return option.name.indexOf(inputValue) > -1
  }

  const rules = {
    name: [
      {
        required: true,
        message: '请输入流程定义名称',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    processNodeIds: [
      {
        required: true,
        message: '未创建流程，请将节点添加到右侧',
        trigger: 'change',
      },
    ],
  }

  //表单提交
  const emit = defineEmits(['submit'])
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建流程错误：', error)
      })
  }
  async function handelCreate(data) {
    if (!data?.processNodeIds?.length)
      return message.warn('未创建流程，请将节点添加到右侧')
    const ajaxFn = props.isEdit ? updateProcDef : createProcDef
    const messageText = props.isEdit ? '编辑' : '创建'
    const res = await ajaxFn({
      ...data,
      processNodeIds: data.processNodeIds.toString(),
    })
    if (res.success) {
      message.success(messageText + '流程成功！')
      emit('submit')
    } else {
      message.warn(messageText + '流程错误：', res.message)
    }
  }

  function resetForm() {
    formRef.value.resetFields()
    formState.processNodeIds = []
  }
</script>
<style lang="less" scoped>
  .process-definition-action {
    display: flex;
  }
</style>
